// Single source of truth for the default ("house") look & feel.
//
// This object captures the current AllBasketball.co.uk branding. Partner
// overrides (resolved at runtime from /api/partner-config) are merged on top
// of this in src/theme/partnerTheme.js, so anything a partner does NOT specify
// simply falls back to these values. With no ?partner= in the URL the app
// renders exactly with the values below — i.e. unchanged from before.

export const DEFAULT_FONT_BODY =
  "'Inter', system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif";
export const DEFAULT_FONT_HEADING =
  "'Montserrat', system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif";

export const defaultTheme = {
  slug: null,
  colors: {
    primary: '#673de6',
    primaryDark: '#5025d1',
    primaryLight: '#ebe4ff',
    text: '#1d1e20',
    muted: '#727586',
    bg: '#ffffff',
    card: '#f7f8fc',
    border: '#e6e7eb'
  },
  fonts: {
    body: DEFAULT_FONT_BODY,
    heading: DEFAULT_FONT_HEADING
  },
  brand: {
    logoUrl: '/allbasketball_banner.png',
    logoAlt: 'AllBasketball.co.uk',
    homeUrl: 'https://allbasketball.co.uk'
  },
  navLinks: [
    { label: 'Home', href: 'https://allbasketball.co.uk' },
    { label: 'Shop', href: 'https://allbasketball.co.uk/shop' },
    { label: 'Court Finder', href: 'https://allbasketball.co.uk/courts', active: true }
  ],
  // The main site shows the global nav; partners default to hiding it so it
  // never clashes with their own menus.
  showGlobalNav: true,
  mapPin: {
    url: '/markers/MapPin.png',
    width: 50,
    height: 72
  },
  // Monetisation knobs (used in a later phase). Defaults keep current behaviour.
  showAds: true,
  adChannel: ''
};

// Maps a resolved theme onto the CSS custom properties declared in index.css.
// Used by partnerTheme.js to apply overrides on document.documentElement.
export const themeToCssVars = (theme) => {
  const colors = (theme && theme.colors) || {};
  const fonts = (theme && theme.fonts) || {};
  const vars = {};
  const setVar = (name, value) => {
    if (typeof value === 'string' && value.trim()) {
      vars[name] = value.trim();
    }
  };
  setVar('--primary', colors.primary);
  setVar('--primary-dark', colors.primaryDark);
  setVar('--primary-light', colors.primaryLight);
  setVar('--text', colors.text);
  setVar('--muted', colors.muted);
  setVar('--bg', colors.bg);
  setVar('--card', colors.card);
  setVar('--border', colors.border);
  setVar('--font-body', fonts.body);
  setVar('--font-heading', fonts.heading);
  return vars;
};

export default defaultTheme;
